import { useQuery, UseQueryOptions, QueryKey } from '@tanstack/react-query';

/**
 * Generic hook for GET requests using react-query.
 * @param key Unique query key
 * @param fetcher Function that returns a promise
 * @param options react-query options
 */
export function useApiQuery<TQueryFnData, TError = unknown, TData = TQueryFnData>(
    key: QueryKey,
    fetcher: () => Promise<TQueryFnData>,
    options?: Omit<UseQueryOptions<TQueryFnData, TError, TData, QueryKey>, 'queryKey' | 'queryFn'>
) {
    return useQuery<TQueryFnData, TError, TData, QueryKey>({
        queryKey: key,
        queryFn: fetcher,
        ...options,
    });
}